import { WorkSheet, read, utils, write } from 'xlsx';

export const ProcessExcelHeaders = async (
  file: File,
  headerMapping: { [key: string]: string },
): Promise<File> => {
  const data = await file.arrayBuffer();
  const workbook = read(data);
  const sheetName = workbook.SheetNames[0] as string;
  const worksheet = workbook.Sheets[sheetName] as WorkSheet;

  const jsonData = utils.sheet_to_json(worksheet, {
    header: 1,
  });

  if (jsonData.length > 0) {
    const headers = jsonData[0] as string[];
    const newHeaders = headers.map(header => headerMapping[header] || header);
    jsonData[0] = newHeaders;
  }

  const newWorksheet = utils.aoa_to_sheet(jsonData as any[][]);
  const newWorkbook = utils.book_new();
  utils.book_append_sheet(newWorkbook, newWorksheet, sheetName);

  const excelBuffer = write(newWorkbook, { bookType: 'xlsx', type: 'array' });
  const newFile = new File([excelBuffer], file.name, {
    type: file.type,
  });

  return newFile;
};

export const ValidateHeaders = async (file: File, expectedHeders: string[]) => {
  const data = await file.arrayBuffer();
  const workbook = read(data);
  const sheetName = workbook.SheetNames[0]as string;
  const worksheet = workbook.Sheets[sheetName] as WorkSheet;

  const jsonData = utils.sheet_to_json(worksheet, {
    header: 1,
  });
  const headers = jsonData[0] as string[];

  // Check if the headers match the expected format
  const isValid = expectedHeders.every((header) => headers.includes(header));

  return isValid;
};
